import {ReactNode} from 'react';
import * as css from './CoverContent.css';

interface DateTimeItemProps {
    label?: string;
    value: string;
    icon: ReactNode;
    'data-cy'?: string;
}

function DateTimeItem({label, value, icon, 'data-cy': dataCy}: DateTimeItemProps) {
    return (
        <css.col data-cy={dataCy}>
            {label && <css.label>{label}</css.label>}
            <css.value>
                <span>{value}</span>
                {icon}
            </css.value>
        </css.col>
    );
}

export default DateTimeItem;
